import { MetricsSelectionRowCtrl } from './metrics-selection-row.controller';

export const MetricsSelectionRowComponent = {
  controller: MetricsSelectionRowCtrl,
  bindings: {
    label: '<',
    cohort: '<',
    currentSchool: '<',
    metrics: '<',
  },
  template: require('./metrics-selection-row.html'),
};
